import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
// reactstrap components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import classNames from "classnames";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
// reactstrap components

interface IProps {
  isOpen: boolean;
  meetingId: number;
  surveyId: number;
  actionName: string;
  toggle: () => void;
  onSubmit: () => void;
}

const SurveyActionModal: React.FC<IProps> = ({
  meetingId,
  surveyId,
  isOpen,
  actionName,
  toggle,
  onSubmit,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [IsVisible, setIsVisible] = useState(false);
  const [Title, setTitle] = useState("");
  const [message, setmessage] = useState("");
  const { LoadSurveyDetail, resetSurveyDetails } = rootStore.surveyStore;
  const [t] = useTranslation(["surveys", "translation"], translationHookOptions);

  const handleConfirm = () => {
    onSubmit();
    toggle();
  };

  const handleCancel = () => {
    toggle();
  };

  useEffect(() => {
    LoadSurveyDetail(meetingId, surveyId)
      .then((dto) => {
        if (actionName === "Clear") {
          if (dto.survey.answers) {
            if (!dto.survey.isOpen) {
              setmessage(t("survey_action_modal_delete_confirm_message"));
              setIsVisible(true);
            } else {
              setmessage(t("survey_action_modal_close_first_message"));
              setIsVisible(false);
            }
          } else {
            setmessage(t("survey_action_modal_empty_message"));
            setIsVisible(false);
          }
        }

        if (actionName === "Delete") {
          if (!dto.survey.isOpen && !dto.survey.answers) {
            setmessage(t("survey_action_modal_delete_confirm_message"));
            setIsVisible(true);
          } else {
            setmessage(t("survey_action_modal_closereset_message"));
            setIsVisible(false);
          }
        }
        if (actionName === "Close") {
          setmessage(t("survey_action_modal_close_confirm_message"));
          setIsVisible(true);
        }
        if (actionName === "Open") {
          setmessage(t("survey_action_modal_open_confirm_message"));
          setIsVisible(true);
        }
        if (actionName === "Archivie") {
          if (dto.survey.isOpen) {
            setmessage(t("survey_action_modal_archiveclose_message"));
            setIsVisible(false);
          } else {
            setmessage(t("survey_action_modal_archive_confirm_message"));
            setIsVisible(true);
          }
        }
      })
      .catch();

    if (isOpen) {
      if (actionName === "Clear") setTitle(t("survey_action_modal_reset_title"));
      if (actionName === "Open") setTitle(t("survey_action_modal_open_title"));
      if (actionName === "Close") setTitle(t("survey_action_modal_close_title"));
      if (actionName === "Delete") setTitle(t("survey_action_modal_delete_title"));
      if (actionName === "Archivie") setTitle(t("survey_action_modal_archive_title"));
    }

    return () => {
      resetSurveyDetails();
    };
  }, [isOpen, LoadSurveyDetail]);

  return (
    <>
      <Modal
        className="modal-dialog-centered SurveyActionModal"
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
      >
        {Title && 
        <ModalHeader 
        toggle={toggle} 
        style={{height:"10px"}}
        className={classnames(`${theme!.headerModal} ${theme!.headerTextColor}`)}
        close={
          <button className="closeModalIcon" onClick={() => toggle()}>
            <i className="far fa-times-circle fa-lg"></i>
          </button>
        }
        
        >{Title}</ModalHeader>}
        <ModalBody>
          {/* SURVEY ID {surveyId} */}
          {message}
        </ModalBody>
        <ModalFooter>
          {IsVisible && (
            <>
              <Button
                            // color="btn-light"
                className={classNames(
                  "genericButton",
                  `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                )}
                onClick={handleConfirm}
              >
                {t("confirm", { ns : "translation" })}
              </Button>
              <Button
              // color="btn-light"
                className={classNames(
                  "genericButton",
                  `${theme!.buttonSecondaryColor} ${theme!.buttonSecondaryBorderColor} ${theme!.buttonSecondaryTextColor}`
                )}
                onClick={handleCancel}
              >
                {t("cancel", { ns : "translation" })}
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default observer(SurveyActionModal);
